import { useMemo } from 'react'
import type { ChartDescriptor } from '../../charts'
import { useChartDimensions } from '../../charts/visxPrimitives'
import { CHART_REGISTRY } from '../registry'

export const ChartCanvasPanel = ({ descriptor }: { descriptor: ChartDescriptor }) => {
  const { ref, dimensions } = useChartDimensions<HTMLDivElement>()
  const renderer = CHART_REGISTRY[descriptor.kind]
  const Canvas = renderer.Canvas
  const chartSize = useMemo(() => ({
    width: Math.max(320, dimensions.width || 720),
    height: Math.max(260, dimensions.height || 420),
  }), [dimensions.height, dimensions.width])

  return (
    <section className="analysisChartCanvasPanel" ref={ref}>
      <Canvas data={descriptor.data} width={chartSize.width} height={chartSize.height} descriptor={descriptor} />
    </section>
  )
}
